import script from "./AddFamilyMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFamilyMember.vue?vue&type=script&setup=true&lang=js"

import "./AddFamilyMember.vue?vue&type=style&index=0&id=3d4b1552&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4b1552"]])

export default __exports__